import getComponentName from './getComponentName';
import isTag from './isTag';
export default function generateDisplayName(target) {
    return isTag(target) ? "styled.".concat(target) : "Styled(".concat(getComponentName(target), ")");
}
//# sourceMappingURL=generateDisplayName.js.map